import React from "react";
import { Nav } from "./PSY/Nav";
import { SideNav } from "./SideNav";
import logo from "../assets/images/logo.svg"

export const Header: React.FC = ({ children }) => {
  return (
    <div className="flex flex-row justify-center fixed top-0 z-40 bg-component h-20 w-full py-5 px-4 md:px-10">
      <div className="flex flex-row justify-between items-stretch header-container w-full">
        <div className="flex flex-row items-center">
          <img src={logo} alt="PSY logo"/>
          <div className="ml-8">
            <Nav />
          </div>
        </div>
        <div className="flex flex-row justify-between">
          {children}
          <SideNav/>
        </div>
      </div>
    </div>
  );
};
